var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"value":_vm.selectedVatPercentage,"label":_vm.$localize('SelectVat.label'),"items":_vm.vat,"item-text":_vm.getItemText,"item-value":"vatPercentage","clearable":_vm.clearable,"loading":_vm.loading,"autofocus":_vm.autofocus,"rules":_vm.rules},on:{"input":function($event){return _vm.onVatSelected($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }